import React, 
    { 
    useState, 
    useEffect 
} from 'react';
import { 
    useParams, 
    useHistory, 
    useLocation 
} from 'react-router-dom';
import backArrow from '../../assets/images/arrow.svg';
import { useSelector } from 'react-redux';
import CircularLoader from '../../utils/Loaders/CircularLoader';
import { toast } from 'react-toastify';
import { 
    Get, 
    Post 
} from '../../Api/ApiMethods.js';
import { 
    addNewVehicleUrl,
    getVehicleTypesUrl
 } from '../../Routes/ApiRoutes';
import VehicleImage from './VehicleImage';
import selectArrow from '../../assets/images/selectArrow.svg';

export default function AddVehicle() {
    const token = useSelector((state) => state.auth.isSignedIn);
    const {pathname} = useLocation();
    const history = useHistory();
    const {id} = useParams();
    const [loader, setLoader] = useState(false);
    const [vehicleType, setVehicleType] = useState(null);
    const [data, setData] = useState({
        "length": '',
        "width": '',
        "reg_no": "",
        "vehicle_image": "",
        "vehicle_type": '0',
        "registration_doc": "",
        "description": ""
      });
    const [vehicleTypeError, setVehicleTypeError] = useState(null);
    const [descriptionError, setDescriptionError] = useState(null);
    const [regNoError, setRegNoError] = useState(null);
    const [lengthError, setLengthError] = useState(null);
    const [widthError, setWidthError] = useState(null);
    const [licenceError, setLicenceError] = useState(null);
    const [imageError, setImageError] = useState(null);

    useEffect(() => {
        fetchVehicleType()
    }, [])

    const fetchVehicleType = () => {
        try {
            Get(getVehicleTypesUrl, token)
            .then(res => {
                if(res.status === 200){
                    setVehicleType(res.data);
                }
            })
            .catch(error => {
                toast.error(error.error)
            })
          }catch (error) {
            toast.error(error.error)
        }
    }

    const handleSubmitButton = () => {
        if(data.vehicle_type === '0'){
            setVehicleTypeError('Vehicle type is mandatory.');
        }
        if(data.description === ''){
            setDescriptionError('Description is mandatory.');
        }
        if(data.reg_no === ''){
            setRegNoError('Registration number is mandatory.');
        }
        if(data.width === ''){
            setWidthError('Width of vehicle is mandatory.');
        }
        if(data.length === ''){
            setLengthError('Length of vehicle is mandatory.');
        }
        if(data.vehicle_image === ''){
            setImageError('Vehicle image is mandatory.');
        }
        if(data.registration_doc === ''){
            setLicenceError('Driver licence is mandatory.');
        }
        if(data.vehicle_type !== '0' && data.description !== '' && data.reg_no !== '' && data.width !== '' && 
        data.length !== '' && data.registration_doc !== '' && data.vehicle_image !== '' && !(imageError) && 
        !(vehicleTypeError) && !(descriptionError) && !(regNoError) && !(lengthError) && !(widthError) && 
        !(licenceError)){
            setLoader(true);
            try {
                Post(addNewVehicleUrl, token, data)
                .then(res => {
                        toast.success(res.message);
                        setLoader(false);
                        if(pathname === '/profile/vehicleList/addVehicle'){
                            setTimeout(() => {
                                history.push(`/profile/vehicleList`);
                            },2100)
                        }else{
                            setTimeout(() => {
                                history.push(`/booking/vehicleList/${id}`)
                            },2100)
                        }
                })
                .catch(error => {
                    toast.error(error.error);
                    setLoader(false);
                })
            }catch (error) {
                toast.error(error.error);
                setLoader(false);
            }
        }
    }
    
    const handleVehicelTypeChange = (e) =>{
        let updatedDetails = { ...data };
        updatedDetails[e.target.id] = e.target.value;
        setData(updatedDetails);
        if(e.target.value === '0'){
            setVehicleTypeError('Vehicle type is mandatory.');
        }else{
            setVehicleTypeError(null);
        }
    }

    const handleDescriptionChange = (e) =>{
        let updatedDetails = { ...data };
        updatedDetails[e.target.id] = e.target.value;
        setData(updatedDetails);
        if(e.target.value === ''){
            setDescriptionError('Description is mandatory.');
        }else{
            setDescriptionError(null);
        }
    }

    const handleRegistrationNoChange = (e) =>{
        let updatedDetails = { ...data };
        updatedDetails[e.target.id] = e.target.value;
        setData(updatedDetails);
        if(e.target.value === ''){
            setRegNoError('Registration number is mandatory.');
        }else if(e.target.value.length > 18){
            setRegNoError('Length of registration number can not exceed 18 character.');
        }else{
            setRegNoError(null);
        }
    }

    const handleWidthChange = (e) =>{
        let updatedDetails = { ...data };
        updatedDetails[e.target.id] = e.target.value;
        setData(updatedDetails);
        if(e.target.value === ''){
            setWidthError('Width of vehicle is mandatory.');
        }else if(isNaN(e.target.value)){
            setWidthError('Width must be a number.');
        }else{
            setWidthError(null);
        }
    }

    const handleLengthChange = (e) =>{
        let updatedDetails = { ...data };
        updatedDetails[e.target.id] = e.target.value;
        setData(updatedDetails);
        if(e.target.value === ''){
            setLengthError('Length of vehicle is mandatory.');
        }else if(isNaN(e.target.value)){
            setLengthError('Length must be a number.');
        }else{
            setLengthError(null);
        }
    }

    return (
        <>
            {loader && <CircularLoader />}
                <section className="Added-vehicles-wrapper">
                    <div className="container">
                        <div className="col-md-9 col-sm-12 padding-rt">
                            <div className="Add-vehicle-detail">
                            <h3><img onClick={() => {
                                    if(pathname === '/profile/vehicleList/addVehicle'){
                                            history.push(`/profile/vehicleList`);
                                        }else{
                                            history.push(`/booking/vehicleList/${id}`)
                                        }
                                    }} className="mr-2 cursorP" src={backArrow} />
                                Add your vehicle detail
                            </h3>
                            <div className="form-group">
                                {/* <img className='selectImage' src={selectArrow} onClick={()=>{
                                    var x = document.getElementById('vehicle_type').click();
                                }} /> */}
                                <select className={vehicleTypeError ? "form-control borderRed" : "form-control" }
                                onChange={(e) => handleVehicelTypeChange(e)} id='vehicle_type' 
                                type="text" placeholder="Type of vehicle">
                                    <option value='0'>Type of vehicle</option>
                                    {vehicleType && vehicleType.map((item) => 
                                        <option key={item.id} value={item.id}>{item.type_name}</option>
                                    )}
                                </select>
                                {vehicleTypeError && <span className='form-error'>{vehicleTypeError}</span>}
                            </div>
                            <div className="form-group">
                                <input className={descriptionError ? "form-control borderRed" : "form-control" }
                                onChange={(e) => handleDescriptionChange(e)} id='description' 
                                type="text" placeholder="Description" />
                                {descriptionError && <span className='form-error'>{descriptionError}</span>}
                            </div>
                            <div className="form-group">
                                <input className={regNoError ? "form-control borderRed" : "form-control" }
                                onChange={(e) => handleRegistrationNoChange(e)} id='reg_no' type="text" 
                                placeholder="Registration number" />
                                {regNoError && <span className='form-error'>{regNoError}</span>}
                            </div>
                            <div className="row no-gutters">
                                <div className="col-md-6 padding-rt">
                                    <div className="form-group">
                                        <input className={lengthError ? "form-control borderRed" : "form-control" }
                                        onChange={(e) => handleLengthChange(e)} id='length' type="text" 
                                        placeholder="Vehicle length in feet" />
                                        {lengthError && <span className='form-error'>{lengthError}</span>}
                                    </div>
                                </div>
                                <div className="col-md-6 padding-lt">
                                    <div className="form-group">
                                        <input className={widthError ? "form-control borderRed" : "form-control" }
                                        onChange={(e) => handleWidthChange(e)} id='width' type="text" 
                                        placeholder="Vehicle Width in feet" />
                                        {widthError && <span className='form-error'>{widthError}</span>}
                                    </div>
                                </div>
                            </div>
                            <div className="upload-details">
                                <>
                                    <VehicleImage
                                        buttonName='Upload licence'
                                        tittleName='Driver licence'
                                        setLoader={setLoader}
                                        data={data}
                                        setData={setData}
                                        id='registration_doc'
                                        dirName={process.env.React_App_S3_Licence_directory}
                                        mainData={data.registration_doc}
                                        imageId='licenceImage'
                                        inputId='licenceInput'
                                        errorMessage={licenceError}
                                        setErrorMessage={setLicenceError}
                                    />
                                </>
                                <>
                                    <VehicleImage
                                        buttonName='Vehicle image'
                                        tittleName='Vehicle image'
                                        setLoader={setLoader}
                                        data={data}
                                        setData={setData}
                                        id='vehicle_image'
                                        dirName={process.env.React_App_S3_Vehicle_directory}
                                        mainData={data.vehicle_image}
                                        imageId='vehicleImage'
                                        inputId='vehicleInput'
                                        errorMessage={imageError}
                                        setErrorMessage={setImageError}
                                    />
                                </>
                            </div>
                            <div className=" comman-btn form-group">
                                <button onClick={() => handleSubmitButton()}>Save</button>
                            </div> 
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
